import types from '../../actions/types'
import { combineReducers } from 'redux'

export const visible = (state = false, action) => {
  switch (action.type) {
    case types.PRICE_LISTS_SHOW_MOVE_PARTS_DIALOG: return true
    case types.PRICE_LISTS_HIDE_MOVE_PARTS_DIALOG: return false
    default:
      return state
  }
}

export const selectedParts = (state = [], action) => {
  switch (action.type) {
    case types.PRICE_LISTS_SHOW_MOVE_PARTS_DIALOG:
      return action.selectedParts
    case types.PRICE_LISTS_HIDE_MOVE_PARTS_DIALOG:
      return []
    default:
      return state
  }
}

export default combineReducers({
  visible,
  selectedParts,
})
